import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,       // 60s — reduce excessive refetching for static data
      gcTime: 5 * 60 * 1000,      // Keep in memory for 5 min
      refetchOnMount: true,        // Refetch on mount
      refetchOnWindowFocus: true,  // Refetch when tab regains focus
      refetchOnReconnect: true,    // Refetch on reconnect
      retry: 1,                    // Retry once on failure
    },
  },
});
